import { forwardRef } from "react";

const withHeaderTitle = (Component: React.ComponentType<any>) => {
  return forwardRef(({ children, ...props }: { children?: React.ReactNode }, ref) => {
    return (
      <Component {...props} ref={ref}>
        {children !== undefined ? children : null}
      </Component>
    );
  });
};

const withHeaderCloseButton = (
  Component: React.ComponentType<any>,
  CloseButtonComponent: React.ComponentType<any>,
) => {
  return forwardRef(
    ({ close, children, ...props }: { close?: () => void; children?: React.ReactNode }, ref) => {
      return (
        <Component {...props} ref={ref}>
          {close !== undefined ? (
            <CloseButtonComponent close={close}>{children}</CloseButtonComponent>
          ) : null}
        </Component>
      );
    },
  );
};
export { withHeaderTitle, withHeaderCloseButton };
